export interface SpecializzazioneResponse {
    id: string;
    nome: string;
    codice: string;
    stato: string;
}